import { Component, ElementRef, OnInit } from '@angular/core';
import { HomeService } from 'src/app/services/home.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-research-topics',
  templateUrl: './research-topics.component.html',
  styleUrls: ['./research-topics.component.css']
})
export class ResearchTopicsComponent implements OnInit {
  arrayResearchTopicCategroy:any
  arrayResearchTopics:any
  id: any
  selectedItem: any
  load: boolean = false
  constructor(private elementRef: ElementRef,private homeService_: HomeService,private _Activatedroute: ActivatedRoute) {
    this._Activatedroute.paramMap.subscribe(params => {
      this.ngOnInit();
      window.scroll(0, 0);
    });
   }
   ngOnInit(): void {
    this.load = false
    this.id = this._Activatedroute.snapshot.paramMap.get("id")

    var s15 = document.createElement("script");
    s15.type = "text/javascript";
    s15.src = "../../../assets/js/plugins.js";
    this.elementRef.nativeElement.appendChild(s15);

    var s15 = document.createElement("script");
    s15.type = "text/javascript";
    s15.src = "../../../assets/js/main.js";
    this.elementRef.nativeElement.appendChild(s15);

    if (this.id == null || this.id == '') {
      this.selectedItem = null

      this.homeService_.getPost('getPost','', 'en', '', 'ResearchTopicCategroy', 'NTROOT0', '', '-1').subscribe(data => {
        this.arrayResearchTopicCategroy = data
        this.homeService_.getPost('getPostDetails', '', 'en', '', 'ResearchTopics', '', '', '-1').subscribe(data => {
          this.arrayResearchTopics = data
          setTimeout(() => {
            this.load = true
          }, 2000);
        })
      })
    }
    else
    this.homeService_.getPost('getPost','', 'en', '', 'ResearchTopicCategroy', 'NTROOT0', '', '-1').subscribe(data => {
      this.arrayResearchTopicCategroy = data
    this.homeService_.getPost('getPostDetails', '', 'en', '', 'ResearchTopics', this.id, '', '-1').subscribe(data => {
          this.selectedItem = this.id
          this.arrayResearchTopics = data
            this.load = true
           })
      })
  }

  getResearchTopics(sectionId: string) {
    this.load = false

    this.selectedItem = sectionId

    this.homeService_.getPost('getPost', '', 'en', '', 'ResearchTopics', "NTROOT0", '', '-1').subscribe(data => {
      this.arrayResearchTopics = data
        this.load = true

    })
  }

}
